/* loaded by smart-asset */
export default require("./logo~bpcUkzrS.svg")